// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_kx-0";
export var buttonContainer = "_kx-3";
export var cancelButton = "_kx-4";
export var headerSection = "_kx-6";
export var headerTitle = "_kx-9";
export var messageSideLeft = "_kx-1";
export var messageSideRight = "_kx-2";
export var orderNumberContainer = "_kx-7";
export var orderNumberLabel = "_kx-8";
export var submitButton = "_kx-5";